import { Fragment, h } from "preact";
import { observer } from "mobx-react";
import WeeklySchedulePopover from "../views/Cart/WeeklySchedulePopover";
function ProductAvailabilityTag(props) {
    const { labelsCreator, schedule } = props;
    return (h(Fragment, null, labelsCreator.labels.map((label) => {
        return schedule !== undefined && label.enabledOnClick ? (h(WeeklySchedulePopover, { id: `label_schedule_${schedule.id.toString()}`, weeklySchedule: schedule.schedule },
            h(Label, { message: `${label.message} >` }))) : (h(Label, { message: label.message }));
    })));
}
function Label(props) {
    return (h("span", { class: "m-badge m-badge--warning", "data-field-id": "productAvailability", "data-field-type": "info", "data-value": "unavailable" }, props.message));
}
export default observer(ProductAvailabilityTag);
